import axios from "../../shared/axios.utils";
import { DASH_API } from "../../shared/url.consts";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { LoanDetails } from "../../types/loan-details";
import { AppInsightsErrorType } from "../../shared/insights/app-insights.consts";
import { sendAppInsightsServerError } from "../../shared/insights/app-insights.utils";

export const returnLoanDetails = async (loanId: string) => {
  return axios.get<LoanDetails>(`${DASH_API}/loans/${loanId}/details`);
};

export const returnLoanDetailsResponse = async (loanId: string) => {
  try {
    const response = await returnLoanDetails(loanId);
    if (response.status === 200) {
      return response.data;
    } else {
      sendAppInsightsServerError(
        `non 200 response received: ${response}`,
        AppInsightsErrorType.GET_LOAN_DETAILS
      );
      return response.data;
    }
  } catch (err: any) {
    sendAppInsightsServerError(
      `error fetching loan application: ${err}`,
      AppInsightsErrorType.GET_LOAN_DETAILS
    );
  }
};

export const fetchLoanDetails = createAsyncThunk(
  "loan-details/get",
  returnLoanDetailsResponse
);
